import { TableBody } from './TableBody';
import { TableFilter } from './TableFilter';
import { TableFilters } from './TableFilters';
import { TableGrid } from './TableGrid';
import { TableHeader } from './TableHeader';
import { TableMenu } from './TableMenu';
import { TablePagination } from './TablePagination';
import { TableRoot } from './TableRoot';
import { TableRow } from './TableRow';
import { TableSearch } from './TableSearch';
import { TableSelectAll, TableSelectRow } from './TableSelect';
import { TableSelection } from './TableSelection';

export const Table = {
  Root: TableRoot,
  Menu: TableMenu,
  Grid: TableGrid,
  Header: TableHeader,
  Body: TableBody,
  Row: TableRow,
  Search: TableSearch,
  Filters: TableFilters,
  Filter: TableFilter,
  Pagination: TablePagination,
  Selection: TableSelection,
  SelectAll: TableSelectAll,
  SelectRow: TableSelectRow,
};
